/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
// import './src/css/typography.css';

exports.onRouteUpdate = () => {
	if (typeof window !== `undefined`) {
		if (window.location.hash === '') window.scrollTo(0, 0);
	}
};

exports.shouldUpdateScroll = (args) => {
	return false;
};
